export const PLAN_STANDARD = 'standard';
export const PLAN_PREMIER = 'premier';
export const PLAN_ENTERPRISE = 'enterprise';

export const YEAR_MONTHS = 12;

export const THOUSAND_PLUS = '1000+';

export const PLAN_YEARLY = 'yearly';
export const PLAN_MONTHLY = 'monthly';

export const PLAN_HR = 'hr';
export const PLAN_RECRUITING = 'recruiting';
export const PLAN_BUNDLE = 'bundle';
